import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import StripeChargeEventTableHead from '../../components/molecules/StripeChargeEventTableHead';
import StripeChargeEventTableBody from '../../components/molecules/StripeChargeEventTableBody';
import GroupIdentityRegister from './GroupIdentityRegister';
import GroupIdentityApproval from './GroupIdentityApproval';
import ExPagination from '../../components/molecules/ExPagination';
import { getStripeChargeEvents } from '../../actions/StripeChargeEvent';
import { sendLogin } from '../../auth/Auth';
import {
  resendMailGochiData,
  // resendGochiData,
  rejectGochiData
} from '../../libs/apis/GochiApi';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      stripeChargeEvents: state.stripeChargeEvents.stripeChargeEvents,
      totalCount: state.stripeChargeEvents.totalCount,
      offset: state.stripeChargeEvents.offset
    }),
    dispatch => ({
      actions: bindActionCreators({ getStripeChargeEvents }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openRegisterModal', 'updateOpenRegisterModal', false),
  withState('openApprovalModal', 'updateOpenApprovalModal', false),
  withState(
    'openApprovalConfirmModal',
    'updateOpenApprovalConfirmModal',
    false
  ),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('identityId', 'setIdentityId', null),
  withState('shopId', 'setShopId', null),
  withState('sealCertificate', 'setSealCertificate', null),
  withState('businessLicense', 'setBusinessLicense', null),
  withState('other', 'setOther', null),
  withState('note', 'setNote', null),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('page', 'setPage', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    roles,
    progress,
    stripeChargeEvents,
    searchKey,
    page,
    selectedPage,
    totalCount,
    offset,
    handleChangePage,
    openRegisterModal,
    updateOpenRegisterModal,
    openApprovalModal,
    updateOpenApprovalModal,
    openApprovalConfirmModal,
    updateOpenApprovalConfirmModal,
    rowsPerPage,
    handleChangeRowsPerPage,
    identityId,
    setIdentityId,
    shopId,
    setShopId,
    sealCertificate,
    setSealCertificate,
    businessLicense,
    setBusinessLicense,
    other,
    setOther,
    note,
    setNote,
    targetRowId,
    setTargetRowId
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    const detail = {
      identityId,
      shopId,
      sealCertificate,
      businessLicense,
      other,
      note
    };

    const registerOpenAction = params => {
      updateOpenRegisterModal(true);
      setTargetRowId(params.id);
    };
    const confirmOpenAction = async params => {
      setIdentityId(params.identityId);
      setShopId(params.shopId);
      setSealCertificate(params.sealCertificate);
      setBusinessLicense(params.businessLicense);
      setOther(params.other);
      setNote(params.note);
      updateOpenApprovalModal(true);
    };

    const resendMailAction = params => {
      progress.updateOpenProgress(true);
      resendMailGochiData({ chargeId: params.chargeId })
        .then(async data => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          if (data.status === 200) {
            alert('成功しました。');
            handleChangePage(null, 1, rowsPerPage.textContent);
          } else {
            alert('失敗しました');
          }
        })
        .catch(() => {
          alert('失敗しました');
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };

    const resendGochiAction = params => {
      window.open(`${params.successUrl}&admin=true`, '_blank');
      handleChangePage(null, 1, rowsPerPage.textContent);
      // progress.updateOpenProgress(true);
      // resendGochiData({ paymentIntent: params.paymentIntent })
      //   .then(async data => {
      //     progress.updateOpenProgress(false);
      //     progress.updateLoading(false);
      //     if (data.status === 200) {
      //       alert('成功しました。');
      //       handleChangePage(null, 1, rowsPerPage.textContent);
      //     } else {
      //       alert('失敗しました');
      //     }
      //   })
      //   .catch(() => {
      //     alert('失敗しました');
      //     progress.updateOpenProgress(false);
      //     progress.updateLoading(false);
      //   });
    };

    const rejectGochiAction = params => {
      progress.updateOpenProgress(true);
      rejectGochiData({ chargeId: params.chargeId })
        .then(async data => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          if (data.status === 200) {
            alert('成功しました。');
            handleChangePage(null, 1, rowsPerPage.textContent);
          } else {
            alert('失敗しました');
          }
        })
        .catch(() => {
          alert('失敗しました');
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <StripeChargeEventTableHead roles={roles} />
            <StripeChargeEventTableBody
              stripeChargeEvents={stripeChargeEvents}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              registerOpenAction={registerOpenAction}
              confirmOpenAction={confirmOpenAction}
              updateOpenRegisterModal={updateOpenRegisterModal}
              updateOpenConfirmModal={updateOpenApprovalModal}
              setTargetRowId={setTargetRowId}
              roles={roles}
              resendMailAction={resendMailAction}
              resendGochiAction={resendGochiAction}
              rejectGochiAction={rejectGochiAction}
            />
          </Table>
        </div>
        {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
          <div>
            <ExPagination
              searchResults={stripeChargeEvents}
              rowsPerPage={rowsPerPage}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              totalCount={totalCount}
              offset={offset}
              selectedPage={selectedPage}
            />
          </div>
        )}
        <Modal open={openRegisterModal}>
          <GroupIdentityRegister
            updateOpenRegisterModal={updateOpenRegisterModal}
            searchKey={searchKey}
            targetRowId={targetRowId}
          />
        </Modal>
        <Modal open={openApprovalModal}>
          <GroupIdentityApproval
            updateOpenApprovalModal={updateOpenApprovalModal}
            openApprovalConfirmModal={openApprovalConfirmModal}
            updateOpenApprovalConfirmModal={updateOpenApprovalConfirmModal}
            detail={detail}
            targetRowId={targetRowId}
            searchKey={searchKey}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
